<template>
    <v-autocomplete
        :value="value"
        :items="clubs"
        :loading="isLoading"
        :search-input.sync="search"
        hide-no-data
        item-text="name"
        label="Search Clubs"
        placeholder="Start typing to Search"
        prepend-icon="mdi-account-search"
        return-object
        v-bind="$attrs"
        @input="val => $emit('input', val)"
        @click:clear="() => $emit('input', null)"
    />
</template>

<script>
import axios from 'axios';

export default {
    name: 'ClubSelector',

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },

    data: () => ({
        descriptionLimit: 60,
        clubs: [],
        isLoading: false,
        search: null,
    }),

    watch: {
        search: _.debounce(async function search(val) {
            // Items have already been requested
            if (this.isLoading || !val) return;

            this.isLoading = true;

            try {
                const { data } = await axios.get(`/api/clubs/search?query=${val}`);

                this.clubs = data.data.data;

                this.count = this.clubs.length;
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
            }

            this.isLoading = false;
        }, 500),
    },

    created() {
        if (this.value && !this.clubs.length) {
            this.clubs.push(this.value);
        }
    },
};
</script>
